import { PyMenuItem } from '../hooks';

export const isExternalLink = (path: string) => path.startsWith('http');

export const isPathActive = (pathname: string, path: string) =>
  pathname === path || pathname.startsWith(`${path}/`);

type FlatMenuEntry = { ownerLabel: string; path: string };

const flattenMenuItems = (items: PyMenuItem[]): FlatMenuEntry[] =>
  items.flatMap((item) =>
    item.children
      ? item.children.map((child) => ({ ownerLabel: item.label, path: child.path }))
      : [{ ownerLabel: item.label, path: item.path }]
  );

export const findActiveOwnerLabel = (pathname: string, items: PyMenuItem[]): string | null => {
  const matches = flattenMenuItems(items)
    .filter((entry) => entry.path && !isExternalLink(entry.path))
    .filter((entry) => isPathActive(pathname, entry.path));
  if (matches.length === 0) return null;
  return matches.reduce((best, entry) => (entry.path.length > best.path.length ? entry : best)).ownerLabel;
};

